"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMemoizedIssueCustomFieldMappingsByTypeId = exports.useGetCustomFieldMappingsByIssueTypeId = exports.useCustomFieldIdsWithMappingsForType = void 0;
var _hooks = require("../../state/redux/hooks");
var _issueCustomFieldMappings = require("../../state/redux/ducks/issueCustomFieldMappings");
var _issueTypes = require("../../state/redux/ducks/issueTypes");
var _react = require("react");
var _alloyProvider = require("@adsk/alloy-provider");
var _sortBy = _interopRequireDefault(require("lodash/sortBy"));
var _uniqBy = _interopRequireDefault(require("lodash/uniqBy"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Returns a memoized function that gets an issue type ID and returns an
 * ordered list of all custom fields for that issue type, including custom
 * fields mapped for the entire project and custom fields mapped for the
 * category.
 */
const useGetCustomFieldMappingsByIssueTypeId = () => {
  const customFieldMappings = (0, _hooks.useSelector)(_issueCustomFieldMappings.getCustomFieldMappings);
  const projectId = (0, _alloyProvider.useCurrentProjectId)();
  const issueTypeEntitiesMap = (0, _hooks.useSelector)(_issueTypes.getIssueTypeEntitiesMap);
  return (0, _react.useCallback)(issueTypeId => {
    const attributesFromProjectMapping = (0, _sortBy.default)(customFieldMappings[projectId] || [], "order");
    const issueType = issueTypeEntitiesMap[issueTypeId];
    const categoryId = issueType && issueType.issueTypeCategoryId;
    const attributesFromCategoryMapping = categoryId ? (0, _sortBy.default)(customFieldMappings[categoryId] || [], "order") : [];
    const attributesFromTypeMapping = issueTypeId ? (0, _sortBy.default)(customFieldMappings[issueTypeId] || [], "order") : [];
    return (0, _uniqBy.default)([...attributesFromProjectMapping, ...attributesFromCategoryMapping, ...attributesFromTypeMapping], "id");
  }, [customFieldMappings, projectId, issueTypeEntitiesMap]);
};
exports.useGetCustomFieldMappingsByIssueTypeId = useGetCustomFieldMappingsByIssueTypeId;
const useMemoizedIssueCustomFieldMappingsByTypeId = issueTypeId => {
  const getCustomFieldMappingsByIssueTypeId = useGetCustomFieldMappingsByIssueTypeId();
  return (0, _react.useMemo)(() => getCustomFieldMappingsByIssueTypeId(issueTypeId), [issueTypeId, getCustomFieldMappingsByIssueTypeId]);
};
exports.useMemoizedIssueCustomFieldMappingsByTypeId = useMemoizedIssueCustomFieldMappingsByTypeId;
const useCustomFieldIdsWithMappingsForType = issueTypeId => {
  const issueCustomFieldMappings = useMemoizedIssueCustomFieldMappingsByTypeId(issueTypeId);
  const mappingsByCustomFieldId = {};
  const customFieldIds = issueCustomFieldMappings.map(mapping => {
    // build the mappingsByCustomFieldId object while returning the ordered list of custom field ids
    mappingsByCustomFieldId[mapping.attributeDefinitionId] = mapping;
    return mapping.attributeDefinitionId;
  });
  return {
    customFieldIds,
    mappingsByCustomFieldId
  };
};
exports.useCustomFieldIdsWithMappingsForType = useCustomFieldIdsWithMappingsForType;
//# sourceMappingURL=issueCustomFieldMappingHooks.js.map